module.exports = __webpack_public_path__ + "img/nwitrgb.7ddf1906.svg";